import ICAL from 'ical.js';

const extractCourseInfo = (title) => {
    const match = title.match(/\[([^\]]+)/);
    if (!match) return null;

    const info = match[1];

    const periodMatch = info.match(/P(\d+)/);
    const period = periodMatch ? periodMatch[1] : null;

    const teacherMatch = info.match(/-([^-]+)$/);
    const teacher = teacherMatch ? teacherMatch[1].trim() : null;

    return { period, teacher, raw: info };
};

export const fetchCanvasEvents = async (icsUrl) => {
    console.log('Fetching Canvas events from:', icsUrl);

    const proxies = [
        'https://api.codetabs.com/v1/proxy?quest=',
        'https://thingproxy.freeboard.io/fetch/',
        'https://api.allorigins.win/raw?url=',
    ];

    for (const proxyUrl of proxies) {
        try {
            const url = proxyUrl + encodeURIComponent(icsUrl);
            console.log('Trying proxy:', proxyUrl);

            const response = await fetch(url);

            if (!response.ok) {
                console.log(`Proxy failed with status: ${response.status}`);
                continue;
            }

            const icsData = await response.text();
            console.log('ICS data received, length:', icsData.length);

            const jcalData = ICAL.parse(icsData);
            const comp = new ICAL.Component(jcalData);
            const vevents = comp.getAllSubcomponents('vevent');

            console.log('Found events:', vevents.length);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const oneYearAgo = new Date(today);
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

            const nextWeek = new Date(today);
            nextWeek.setDate(nextWeek.getDate() + 7);

            const allEvents = vevents
                .map(vevent => {
                    try {
                        const event = new ICAL.Event(vevent);

                        let startDate, endDate;
                        try {
                            startDate = event.startDate.toJSDate();
                        } catch (e) {
                            console.warn('Could not parse start date:', e);
                            return null;
                        }

                        try {
                            endDate = event.endDate.toJSDate();
                        } catch (e) {
                            endDate = startDate;
                        }

                        const description = event.description || '';
                        const summary = event.summary || '';
                        const courseInfo = extractCourseInfo(summary);
                        const cleanTitle = summary.replace(/\s*\[([^\]]+)\s*$/, '').trim();

                        let calendarUrl = event.component.getFirstPropertyValue('url');
                        let assignmentUrl = null;
                        let courseId = null;

                        if (calendarUrl) {
                            const courseMatch = calendarUrl.match(/course_(\d+)/);
                            const assignmentMatch = calendarUrl.match(/assignment_(\d+)/);

                            if (courseMatch && assignmentMatch) {
                                courseId = courseMatch[1];
                                assignmentUrl = `https://mvla.instructure.com/courses/${courseId}/assignments/${assignmentMatch[1]}`;
                            } else {
                                assignmentUrl = calendarUrl;
                            }
                        }

                        return {
                            title: cleanTitle,
                            description,
                            startDate: startDate.toISOString(),
                            endDate: endDate.toISOString(),
                            location: event.location,
                            url: assignmentUrl,
                            isSubmitted: false,
                            courseInfo,
                            courseId,
                        };
                    } catch (e) {
                        console.warn('Error parsing event:', e);
                        return null;
                    }
                })
                .filter(event => {
                    if (!event) return false;
                    const eventStartDate = new Date(event.startDate);
                    return eventStartDate >= oneYearAgo;
                });

            const upcomingEvents = allEvents
                .filter(event => {
                    if (!event.startDate) return false;
                    const eventStartDate = new Date(event.startDate);
                    return eventStartDate >= today && eventStartDate <= nextWeek;
                })
                .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

            console.log('All events:', allEvents);
            console.log('Upcoming events:', upcomingEvents);

            return { all: allEvents, upcoming: upcomingEvents };

        } catch (error) {
            console.error(`Error with proxy ${proxyUrl}:`, error);
        }
    }

    console.error('All CORS proxies failed');
    alert('Unable to load Canvas events. All CORS proxies are down. Please try again later.');
    return { all: [], upcoming: [] };
};